// One cooldown per cause: a cause that survives the reload cannot loop forever,
// while an unrelated cause stays free to reload right after.
const RELOAD_COOLDOWN_MS = 30_000;

export const reloadPageOnce = (cause: string): boolean => {
  const storageKey = `lastAutomaticReloadAt:${cause}`;
  const lastReloadedAt = Number(sessionStorage.getItem(storageKey) ?? 0);
  if (Date.now() - lastReloadedAt < RELOAD_COOLDOWN_MS) {
    console.warn(`${cause}: reload cooldown active, skipping reload.`);
    return false;
  }
  sessionStorage.setItem(storageKey, String(Date.now()));
  window.location.reload();
  return true;
};
